import { setEmailConfirmationApi } from '@/api/v1/users/setEmailConfirmationApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const setEmailConfirmation = async (userId: string, token: string) => {
  try {
    const response = await setEmailConfirmationApi(userId, token);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
